import axios from "axios";
import { getRequestOptions } from "../../resources/configs/requests";
import { ACTUALISE_APPOINTMENT_URL } from "../../resources/configs/URL";
import { formatActualiseAppointmentErrorMessage } from "../../resources/messages/ErrorMessage";
import { ActualiseAppointmentResponsePayload } from "./actualiseAppontment.fromApi.types";
import { ActualiseAppointmentRequestPayload } from "./actualiseAppontment.fromUi.types";
import { parseResponse } from "../../resources/handlers/parseResponse/parseResponse";

/**
 * Actualises an appointment
 *
 * POST
 * Endpoint: /ActualiseAppointment
 *
 * @param {string | null} memberIdentifier  Member Identifier of the person we are making this request for
 * @param {string} appointmentId  ID of the appointment
 * @param {string | null} regInstitutionCode  Reg Institution code of this appointment (e.g. "NUP")
 *
 * @returns {ActualiseAppointmentResponsePayload} Response payload from the remote API
 */
const actualiseAppointment = async (
  params: ActualiseAppointmentRequestPayload,
): Promise<ActualiseAppointmentResponsePayload> => {
  try {
    const response = await axios.post<ActualiseAppointmentResponsePayload>(
      ACTUALISE_APPOINTMENT_URL(),
      params,
      getRequestOptions(),
    );
    return parseResponse(response, ACTUALISE_APPOINTMENT_URL());
  } catch (error) {
    const msg = formatActualiseAppointmentErrorMessage(
      ACTUALISE_APPOINTMENT_URL(),
    );
    console.error(msg);
    throw error;
  }
};

export { actualiseAppointment };
